export default __webpack_public_path__ + "static/media/AT-2020-16-4.4322564b.png";